const keys = ['AIzaSyBJcypqssP3KAs4VrRsFvyipaA4icRBhPg', 'AIzaSyBJcypqssP3KAs4VrRsFvyipaA4icRBhPg'];

export const environment = {
  production: true,
  apiUrl: '//api-demo.lantago.com/v2/',
  toasterTimeout: 2000,
  notifications: {
    homeSize: 5,
    pollInterval: 30000
  },
  checks: {
    pollInterval: 30000
  },
  pageElements: 8,
  GOOGLE_API_KEYS: JSON.stringify(keys)
};



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/environments/environment.ts